import ApplicationController from './application_controller';

// Prevents Enter keypress inside single-line text inputs from implicitly
// submitting the form. Users must click the Save button explicitly.
//
// Enter still works in textareas (inserts newline), in rich-text editors
// (CKEditor / contenteditable), and when focus is on an explicit submit
// button — so keyboard submission via the Save button is preserved.
//
// Apply via `data-controller="block-enter-submit"` on the <form>.
export default class extends ApplicationController {
  connect() {
    this.onKeyDown = this.#handle.bind(this);
    this.element.addEventListener('keydown', this.onKeyDown);
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.onKeyDown);
  }

  #handle(event) {
    if (event.key !== 'Enter') return;
    const t = event.target;
    if (!t) return;
    if (t.tagName === 'TEXTAREA') return;
    if (t.isContentEditable) return;
    if (t.type === 'submit' || t.type === 'button') return;
    // Allow Enter on buttons (e.g. modal triggers) — only prevent on inputs.
    if (t.tagName !== 'INPUT') return;
    event.preventDefault();
  }
}
